import React, { useEffect, useState } from "react";
import styles from "./Section.module.css";
import {
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../components";
import { Col, List, Space, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import Modal from "../../../../components/modal/Modal";
import { PlanningTemplatesMiddleware } from "../../../../Store/Middlewares/PlanningTemplatesMiddleware";
import { useLocation, useNavigate } from "react-router-dom";
import { HiOutlineLockClosed } from "react-icons/hi2";
import { VscTrash } from "react-icons/vsc";
import { EditIcon } from "../../../../components/icons/Icons";
import { MdDelete } from "react-icons/md";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";
const Section = () => {
  const {
    state: { publicTemplate, item, screenType, eventData, headrTitle },
  } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tempData = useLocation().state.item;

  const [addSection, setAddSection] = useState(false);
  const [deleteSection, setDeleteSection] = useState(false);
  const [editSection, setEditSection] = useState(false);
  const [sectionDetails, setSectionDetails] = useState();
  const [editSectionDetails, setEditSectionDetails] = useState();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [Visibility, setVisibility] = useState(false);
  const [secList, setSectionlist] = useState([]);

  const role = Storage.getERole("@role");
  // console.log("item?.id//////", item?.id);
  const shared_planning_template_id = item?.id
  // useSelectors
  const user = useSelector((state) => state.AuthReducer.user);
  const SectionList = useSelector(
    (state) => state.PlanningTemplatesReducer.SectionList
  );
  //   console.log("eventData", eventData);

  // useEffect
  useEffect(() => {
    dispatch(PlanningTemplatesMiddleware.getSections({ id: item?.id })).then(
      (data) => {
        setSectionlist(data);
      }
    );
    // .then(
    //   (data) => {
    //     // console.log("datadatadatadata", data);
    //     setSectionlist(data);
    //     setSectionDetails(data[0]);
    //     setTopic(data[0]?.name);
    //     getQuestion(data[0]?.id);
    //   }
    // );
  }, []);

  // functions
  const onCreateSection = () => {
    if (!user?.is_subscribed) {
      dispatch(
        showAlert({
          type: "error",
          message: "Pleare subscribe to add section",
        })
      );
      return;
    }
    if (!title) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory",
        })
      );
    } else {
      setAddSection(false);
      dispatch(
        PlanningTemplatesMiddleware.createSection({
          id: item?.id,
          name: title,
          Description: description,
          visibility: Visibility ? "public" : "client",
        })
      )
        .then((data) => {
          setSectionlist([data, ...secList]);
          setTitle("");
          setDescription("");
          setVisibility(false);
        })
        .catch(() => {
          setAddSection(true);
        });
    }
  };
  const deleteCallback = (data) => {
    let index = secList.findIndex((item) => item.id == data.id);
    setSectionlist((prev) => {
      prev.splice(index, 1);
      return prev;
    });
    dispatch(PlanningTemplatesMiddleware.getSections({ id: item?.id })).then(
      (data) => {
        // console.log("datadatadatadata", data);
        setSectionlist(data);
        setSectionDetails(data[0]);
        // setTopic(data[0]?.name);
        // getQuestion(data[0]?.id);
      }
    );
    setDeleteSection(false);
  };

  const onDeleteSection = () => {
    // console.log('onDeleteSection item',item)
    if (sectionDetails?.planningtemplate_id == item?.id) {
      dispatch(
        PlanningTemplatesMiddleware.deleteSection({
          id: sectionDetails?.id,
        })
      )
        .then(deleteCallback)
        .catch(() => {
          setDeleteSection(false);
        });
    } else {
      let data = {
        section_id: sectionDetails?.id,
        planningtemplate_id: sectionDetails?.planningtemplate_id,
        shared_planning_template_id: shared_planning_template_id
      };
      dispatch(PlanningTemplatesMiddleware.unlinkTemplateSection(data))
        .then(deleteCallback)
        .catch((err) => {
          setSectionDetails(null);
          //   setsectionID(null);
          console.log(err);
        });
    }
  };

  const onEditSection = () => {
    if (!title) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory",
        })
      );
    } else {
      setEditSection(false);
      dispatch(
        PlanningTemplatesMiddleware.editSection({
          template_id: item?.id,
          sectionID: editSectionDetails?.id,
          name: title,
          Description: description,
          visibility: Visibility ? "public" : "client",
        })
      )
        .then((data) => {
          let index = secList.findIndex((item) => item.id == data.id);

          setSectionlist((prev) => {
            prev.splice(index, 1, data);
            return prev;
          });
          setEditSectionDetails(null);
          setTitle("");
          setDescription("");
          setVisibility(false);
        })
        .catch(() => {
          setAddSection(true);
        });
    }
  };
  // renderSectionList
  const renderSectionList = (item, index) => {
    return (
      <div className={styles.listItem}>
        <div
          className={styles.leftCol}
          onClick={() =>
            navigate(
              screenType == "event"
                ? "/events/eventDetail/templates/vendor/templateDetail"
                :
                screenType == "Planning Forms"
                  ? "/templates/vendor/templateDetail/planningForm"
                  : "/templates/vendor/templateDetail",
              {
                state: {
                  headrTitle: headrTitle ? headrTitle : "Templates",
                  publicTemplate: publicTemplate,
                  item: item,
                  screenType: screenType,
                  eventData: eventData,
                  tempData: tempData,
                  shared_planning_template_id: shared_planning_template_id
                },
              }
            )
          }
        >
          {item?.visibility == "public" ? (
            <TextComponent
              text={"(" + item?.visibility + ")"}
              textClass={styles.publicText}
            />
          ) : (
            <HiOutlineLockClosed />
          )}
          <TextComponent
            textClass={`${styles.itemTitle} ${
              // topic === title && styles.itemTitleSelected
              ""
              }`}
          >
            {item?.name}
          </TextComponent>
        </div>
        {role == roles.vendor && (
          <>
            {publicTemplate ? null : (
              //   <>
              <div className={styles.rightCol}>
                <div
                  className={styles.iconBtn}
                  style={{ marginRight: "10px" }}
                  // setDeleteSection(true)
                  onClick={() => {
                    setDeleteSection(true);
                    setSectionDetails(item);
                  }}
                >
                  <VscTrash />
                </div>
                {item?.planningtemplate_id == tempData?.id && (
                  <div
                    className={styles.iconBtn}
                    onClick={() => {
                      setEditSection(true);
                      setEditSectionDetails(item);
                      // setsectionID(item?.id);
                      setTitle(item?.name);
                      setDescription(item?.description);
                      setVisibility(
                        item?.visibility == "public" ? true : false
                      );
                    }}
                  >
                    <EditIcon size={22} />
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
  };
  return (
    <div className={styles.mainCon}>
      <List dataSource={SectionList} renderItem={renderSectionList} />
      {role == roles.vendor && !publicTemplate && (
        <SubmitButton
          title="Add Section"
          btnClass={styles.sectionBtnDark}
          onClick={() => {
            if (!user?.is_subscribed) {
              dispatch(
                showAlert({
                  type: "error",
                  message: "Pleare subscribe to add section",
                })
              );
              return;
            }
            setAddSection(true);
          }}
        />
      )}
      {addSection && (
        <Modal
          isModalOpen={addSection}
          setIsModalOpen={setAddSection}
          closable={true}
          className={styles.modal}
          wideModal
        >
          <div className={styles.modalCon}>
            <TextComponent
              text={"Create section"}
              textClass={styles.modalHeading}
            />
            <Space
              direction="vertical"
              size="small"
              style={{
                display: "flex",
                marginTop: "10px",
              }}
            >
              <InputField
                label="Section Name"
                name="sectionName"
                placeholder="Section Name"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <TextareaField
                label="Section Description"
                name="eventType"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <div className={styles.visiCon}>
                <div className={styles.visiText}>
                  <TextComponent textClass={styles.toggleInputTitle}>
                    {"Visibility"}
                  </TextComponent>
                </div>
                <div>
                  <Switch
                    checked={Visibility}
                    onChange={() => setVisibility(!Visibility)}
                    style={{
                      backgroundColor: Visibility && "var(--primary-color)",
                    }}
                  />
                </div>
              </div>
            </Space>
            <Col>
              <SubmitButton
                title="Add Section"
                btnClass={styles.modalBtnTemplate}
                onClick={onCreateSection}
              />
            </Col>
          </div>
        </Modal>
      )}
      {deleteSection && (
        <Modal
          isModalOpen={deleteSection}
          setIsModalOpen={setDeleteSection}
          closable={true}
          className={styles.modal}
        // wideModal
        >
          <div className={styles.deleteCon}>
            <div className={styles.deleteIcon}>
              <MdDelete />
            </div>
            <TextComponent
              textClass={styles.deleteText}
              text={"Are you sure want to\n delete this section!"}
            />
            <SubmitButton
              title="Yes"
              btnClass={styles.modalBtnTemplate}
              onClick={onDeleteSection}
            />
          </div>
        </Modal>
      )}
      {editSection && (
        <Modal
          isModalOpen={editSection}
          setIsModalOpen={setEditSection}
          closable={true}
          className={styles.modal}
          wideModal
        >
          <div className={styles.modalCon}>
            <TextComponent
              text={"Edit Section"}
              textClass={styles.modalHeading}
            />
            <Space
              direction="vertical"
              size="small"
              style={{
                display: "flex",
                marginTop: "10px",
              }}
            >
              <InputField
                label="Section Name"
                name="sectionName"
                placeholder="Bridal Information"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <TextareaField
                label="Section Description"
                name="eventType"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <div className={styles.visiCon}>
                <div className={styles.visiText}>
                  <TextComponent textClass={styles.toggleInputTitle}>
                    {"Visibility"}
                  </TextComponent>
                </div>
                <div>
                  <Switch
                    checked={Visibility}
                    onChange={() => setVisibility(!Visibility)}
                    style={{
                      backgroundColor: Visibility && "var(--primary-color)",
                    }}
                  />
                </div>
              </div>
            </Space>
            <Col>
              <SubmitButton
                title="Save"
                btnClass={styles.modalBtnTemplate}
                onClick={onEditSection}
              />
            </Col>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Section;
